import { createTheme, Theme } from '@mui/material';

import { globalTheme } from '../../../../../shared/theme/theme';
import { pulse } from '../../../styles/animations/pulse';

export const DragAndDropTheme: Theme = createTheme(globalTheme, {
  components: {
    MuiPaper: {
      styleOverrides: {
        root: {
          '&.drag-and-drop--wrapper': {
            boxShadow: 'none',

            '.icon-image': {
              top: '2px !important',
              left: '-2px !important',
              width: '28px',
              height: '28px',
              zIndex: 10,
            },

            '.drag-and-drop--box': {
              padding: '10px 20px',
              minHeight: '236px',
              width: '448px',
              border: `1px solid ${globalTheme.palette.appGrey.greyPrimary}`,
              borderRadius: '5px',
              textAlign: 'center',
              position: 'relative',

              '&.has-error': {
                '& .drag-and-drop--typography': {
                  color: globalTheme.palette.error.dark,
                },
              },

              '&.is-dragging': {
                cursor: 'move',

                '& .file-upload-icon': {
                  animation: `${pulse} 700ms ease-in-out infinite`,
                },
              },
            },
            '.drag-and-drop--label': {
              position: 'absolute',
              right: '50%',
              transform: 'translateX(50%)',
              bottom: '24px',
            },
            '.drag-and-drop--label-apk': {
              position: 'relative',
              right: '50%',
              marginTop: '62px',
              marginBottom: '57px',
              transform: 'translateX(50%)',
            },
            '.drag-and-drop--helperText': {
              fontSize: '14px',
              marginTop: '16px',
              marginBottom: '16px',
            },
            '.drag-and-drop--files': {
              overflowY: 'auto',
              display: 'flex',
              flexWrap: 'wrap',
              gap: '10px',
              marginBottom: '120px',
            },
            '.drag-and-drop--apk-files': {
              display: 'flex',
              flexWrap: 'wrap',
              flexDirection: 'column',
            },
            '.drag-and-drop--style': {
              padding: '15px 10px 10px 10px',
              width: '44%',
              whiteSpace: 'nowrap',
              textOverflow: 'ellipsis',
              fontSize: '12px',
              position: 'relative',

              '& .icon-close': {
                cursor: 'pointer',
                position: 'absolute',
                top: '5px',
                left: 0,

                '& #clear': {
                  stroke: globalTheme.palette.appWhite.main,
                },
              },
            },
            '.drag-and-drop--apk': {
              height: '19px',
              display: 'flex',
              position: 'relative',
              marginTop: '10px',
            },
            '.drag-and-drop--apk-helper-text': {
              position: 'relative',
              top: '-2px',
              lineHeight: 'normal',
              marginLeft: '15px',
              fontSize: '16px',
            },
            '.drag-and-drop--typography': {
              textAlign: 'left',
              fontSize: '12px',
              color: globalTheme.palette.appGrey.darkGray,
            },
            '.drag-and-drop--img': {
              width: '100%',
              height: '100%',
              boxShadow: `0 2px 10px 0 ${globalTheme.palette.appGrey.dragAndDropBoxShadow}`,
            },
          },
          '.drag-and-drop--button': {
            width: '139px',
            height: '36px',
            border: 'solid',
            fontSize: '14px',
            borderColor: globalTheme.palette.appGrey.lightSilver,
            borderWidth: '1px',
            borderRadius: '4px',
            color: globalTheme.palette.black.main,
            textTransform: 'unset',
            '&:hover': {
              backgroundColor: globalTheme.palette.appGrey.lightSilver,
            },
          },
        },
      },
    },
  },
});
